import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Wrench, Plus, Trash2 } from "lucide-react";

export const TRADES = [["gas", "Gas Safe engineer"], ["electrical", "Electrician (EICR)"], ["epc", "EPC assessor"], ["alarms", "Alarm fitter"], ["documents", "Legionella / risk assessor"], ["licence", "Licensing agent"], ["general", "General contractor"]];
const empty = { name: "", trade: "gas", phone: "", email: "", booking_url: "", notes: "" };

export default function Contractors() {
  const [list, setList] = useState([]);
  const [f, setF] = useState(empty);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/contractors").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    if (!f.name) return toast.error("Name required");
    await api.post("/contractors", f); toast.success("Contractor saved"); setF(empty); setOpen(false); load();
  };
  const del = async (c) => { await api.delete(`/contractors/${c.id}`); load(); };

  return (
    <div className="bg-card border border-border rounded-2xl p-6 lg:col-span-2" data-testid="contractors-card">
      <h2 className="font-heading font-bold mb-1 flex items-center gap-2"><Wrench size={18} /> Your contractors</h2>
      <p className="text-sm text-muted-foreground mb-4">Save your trusted engineers. One tap from any checklist item sends them a booking request — and their certificate auto-files when they email it back.</p>
      <div className="space-y-2">
        {list.map((c) => (
          <div key={c.id} data-testid={`contractor-${c.id}`} className="flex items-center gap-3 p-3 rounded-xl border border-border">
            <div className="flex-1 min-w-0"><div className="font-semibold text-sm">{c.name} <span className="text-xs font-normal text-muted-foreground">· {TRADES.find((t) => t[0] === c.trade)?.[1] || c.trade}</span></div><div className="text-xs text-muted-foreground truncate">{[c.phone, c.email, c.booking_url].filter(Boolean).join(" · ")}</div></div>
            <button data-testid={`contractor-del-${c.id}`} onClick={() => del(c)} className="text-rose-600 p-2 rounded-lg hover:bg-rose-50"><Trash2 size={15} /></button>
          </div>
        ))}
        {list.length === 0 && !open && <p className="text-sm text-muted-foreground">No contractors yet.</p>}
      </div>
      {open ? (
        <div className="mt-3 grid sm:grid-cols-2 gap-3" data-testid="contractor-form">
          <input data-testid="con-name" value={f.name} onChange={set("name")} placeholder="Name / company" className="inp" />
          <select data-testid="con-trade" value={f.trade} onChange={set("trade")} className="inp">{TRADES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
          <input data-testid="con-phone" value={f.phone} onChange={set("phone")} placeholder="Phone" className="inp" />
          <input data-testid="con-email" value={f.email} onChange={set("email")} placeholder="Email (for booking requests)" className="inp" />
          <input data-testid="con-url" value={f.booking_url} onChange={set("booking_url")} placeholder="Online booking link (optional)" className="inp sm:col-span-2" />
          <button data-testid="con-save" onClick={save} className="min-h-[44px] rounded-xl bg-navy text-white font-semibold">Save contractor</button>
          <button onClick={() => setOpen(false)} className="min-h-[44px] rounded-xl border border-border">Cancel</button>
          <style>{`.inp{width:100%;min-height:44px;padding:0 .75rem;border-radius:.6rem;border:1px solid hsl(var(--input));background:hsl(var(--card))}`}</style>
        </div>
      ) : <button data-testid="add-contractor-btn" onClick={() => setOpen(true)} className="mt-3 min-h-[44px] px-4 inline-flex items-center gap-2 rounded-xl border border-border font-medium hover:bg-secondary transition-colors"><Plus size={16} /> Add contractor</button>}
    </div>
  );
}
